"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMPERMAX_CONFIG_MANAGER = void 0;
const types_1 = require("../types");
exports.IMPERMAX_CONFIG_MANAGER = {
    [types_1.Networks.Ropsten]: '',
    [types_1.Networks.Mainnet]: '',
    [types_1.Networks.Polygon]: '0xB72A79979D9CDbBB5BA6FF7d8E99D5e274154794',
    [types_1.Networks.Arbitrum]: '',
    [types_1.Networks.Avalanche]: '',
    [types_1.Networks.Moonriver]: '',
    [types_1.Networks.Aurora]: '',
    [types_1.Networks.Cronos]: '',
    [types_1.Networks.Fantom]: '0x4205329addac66da9d060f6e183f3bc57f0d4705',
    [types_1.Networks.Harmony]: '',
    [types_1.Networks.Moonbeam]: '',
    [types_1.Networks.Sxnetwork]: '',
    [types_1.Networks.Canto]: '',
    [types_1.Networks.ZksyncEra]: '',
    [types_1.Networks.Blast]: '0x5de4c7a691398F01b522ae6C8AdAc649c1E30Cb6',
    [types_1.Networks.Base]: '0x9acafcb281e94eaB771D0cf6508c92A4B75DCE7c',
    [types_1.Networks.Scroll]: '0x90869a451f966d848b85Da57e2a65A545AFb6087',
    [types_1.Networks.Mantle]: '0x6daC1AbEA1E903765358EFD4Ac4e6E817F78F4CB',
    [types_1.Networks.Optimism]: '0xC8301bD3f86e642904aeD9b588cA9d9350b3B160',
    [types_1.Networks.Real]: '0x274C36c461C02B39a110A0801EbB218eC076B79B',
    [types_1.Networks.Sonic]: '0x1A3e33E38D2e70D43f65772f63c5B3f52073b37E',
    [types_1.Networks.Linea]: '0x3A65E736b534B3A3703Eb081b93118852Bf1796a',
};
